/* Svensk katalog for locale-no.js (del 2 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'fi.recheck': 'Jag har bekräftat',
  'fi.stillUnverified': 'Adressen är fortfarande inte bekräftad. Kontrollera inkorgen och skräpposten.',
  'fi.decline': 'Avböj',
  'fi.declined': 'Inbjudan har avböjts.',
  'set.firm.title': 'Redovisningsbyrå',
  'set.firm.sub': 'Byrån får åtkomst till bokföringen först när du godkänner, och förlorar den så fort du avslutar samarbetet.',
  'set.firm.none': 'Inga redovisningsbyråer har åtkomst till det här företaget, och ingen har bett om det.',
  'set.firm.pending': 'Väntar på ditt svar',
  'set.firm.active': 'Har åtkomst',
  'set.firm.end': 'Avsluta samarbetet',
  'set.firm.endConfirm': 'Avsluta samarbetet med {firm}? Medarbetarna förlorar åtkomsten till bokföringen direkt.',
  'set.firm.ended': 'Samarbetet har avslutats och åtkomsten har dragits tillbaka.',
  'set.firm.onlyManagers': 'Endast ägare och administratör kan svara på en förfrågan.',
  'rf.create.title': 'Skapa redovisningsbyrå',
  'rf.create.eyebrow': 'Redovisningsbyrå',
  'rf.create.readyBody': 'Byrån har skapats och du är ägare. Nästa steg är att bjuda in dina medarbetare och koppla klienter.',
  'rf.create.openSurface': 'Öppna byråvyn',
  'rf.create.body': 'Byrån hämtas från Enhetsregisteret. Du blir ägare och kan bjuda in medarbetare efteråt.',
  'rf.create.orgNumber': 'Organisationsnummer',
  'rf.create.hintDigits': 'Nio siffror. Byrån måste vara registrerad i Enhetsregisteret.',
  'rf.create.hintReady': 'Numret hämtas från Enhetsregisteret när du skapar byrån.',
  'rf.create.hintDemo': 'Demokontot kan använda ett påhittat nummer. Ge byrån ett namn nedan.',
  'rf.create.firmName': 'Byråns namn',
  'rf.create.nameRequired': 'Hittade inte företaget i Enhetsregisteret. Ange byråns namn för att fortsätta.',
  'rf.create.unverifiedNote': 'Byrån skapas utan registeruppslag och markeras som overifierad. Den måste verifieras innan riktiga byråer tas i bruk.',
  'rf.create.demoNote': 'Demokontot anger namnet själv. Vanliga konton får namnet från Enhetsregisteret.',
  'rf.create.submit': 'Skapa byrå',
  'rf.create.working': 'Skapar …',
  'rf.create.done': 'Redovisningsbyrån har skapats',
  'rf.create.note': 'Uppslaget bekräftar att företaget finns. Det kontrollerar inte om du får företräda det.',
  'rf.member.title': 'Befattning',
  'rf.member.email': 'E-post',
  'rf.member.person': 'Person',
  'rf.member.rights': 'Behörigheter',
  'rf.member.inviteTitle': 'Bjud in en medarbetare',
  'rf.member.invite': 'Skicka inbjudan',
  'rf.member.inviting': 'Skickar …',
  'rf.member.invited': 'Inbjudan skickad',
  'rf.member.inviteMailFailed': 'Inbjudan har skapats, men e-postmeddelandet kunde inte skickas.',
  'rf.member.listTitle': 'Medarbetare',
  'rf.member.none': 'Inga medarbetare ännu.',
  'rf.member.updated': 'Befattningen har ändrats',
  'rf.member.remove': 'Ta bort åtkomst',
  'rf.member.removed': 'Åtkomsten har tagits bort',
  'rf.member.removedWithClients': 'Åtkomsten har tagits bort, även hos {count} klienter.',
  'rf.member.removeConfirm': 'Ta bort åtkomsten för {name}? All klientåtkomst som byrån har gett den här personen dras tillbaka samtidigt.',
  'rf.member.removeNote': 'När du tar bort en medarbetare dras också all klientåtkomst som byrån har gett personen tillbaka — hos alla klienter, i en och samma åtgärd.',
  'rf.member.ownerRights': 'Ägare av byrån',
  'rf.member.canControl': 'Kan kontrollera',
  'rf.nav.backToApp': 'Till min bokföring',
  'rf.nav.back': 'Tillbaka',
  'app.nobusiness.openFirm': 'Öppna redovisningsbyrån',
  'rf.tab.close': 'Stäng flik',
  'rf.tab.assignFirst': 'Ingen har tilldelats uppdraget för den här klienten ännu. Åtkomsten till bokföringen följer tilldelningen — tilldela någon uppdraget under Klienter.',
  'rf.tab.assignNeeded': 'Du är inte tilldelad uppdraget för den här klienten. Be en administratör på byrån att tilldela dig det.',
  'rf.soon.clients': 'Klientöversikten kopplas nu mot klientstatusen som backend beräknar för varje klient.',
  'rf.soon.reconciliation': 'Avstämningsvyn byggs nu. Åtkomstmodellen och klientstatusen som den bygger på är på plats.',
  'rf.soon.control': 'Kontrollvyn kommer efter avstämningen. Fyraögonprincipen upprätthålls i backend när den lanseras.',
  'rf.noFirm.title': 'Du är inte medlem i en redovisningsbyrå',
  'rf.noFirm.body': 'Du är inte medlem i någon byrå ännu. Skapa en egen nedan, eller be en administratör på byrån att bjuda in dig — inbjudan kommer via e-post.',
  'tc.title': 'Teamchatt',
  'tc.rooms': 'Rum',
  'tc.dms': 'Direktmeddelanden',
  'tc.newRoom': 'Nytt rum',
  'tc.roomName': 'Rumsnamn',
  'tc.roomNamePlaceholder': 'T.ex. Kontrollteamet',
  'tc.createRoom': 'Skapa rum',
  'tc.noColleagues': 'Inga andra på byrån ännu',
  'tc.commonRoom': 'Gemensamt rum',
  'tc.room': 'Rum',
  'tc.commonSubtitle': 'Gemensamt rum för hela teamet',
  'tc.roomSubtitle': 'Rum på byrån',
  'tc.dm': 'Direktmeddelande',
  'tc.dmSubtitle': 'Direktmeddelande',
  'tc.empty': 'Inga meddelanden här ännu — skriv det första.',
  'tc.placeholder': 'Skriv ett meddelande…',
  'tc.send': 'Skicka',
  'tc.unknown': 'Okänd',
  'shell.client.clients': 'Dina klienter',
  'shell.client.signOutSub': 'Avsluta sessionen på den här enheten',
  'shell.client.signOutFailed': 'Det gick inte att logga ut. Försök igen.',
  'shell.client.none': 'Inga företag',
  'shell.client.noBusinesses': 'Inga verksamheter',
  'shell.client.connecting': 'Ansluter till Plumme backend',
  'shell.client.personalEconomy': 'Privatekonomi',
  'shell.client.accountingClient': 'Redovisningsklient',
  'shell.client.org': 'Org. {org}',
  'shell.suggest.invoices': 'Fakturor',
  'shell.suggest.customers': 'Kunder',
  'shell.suggest.vouchers': 'Verifikationer',
  'trial.title': 'Provperioden är aktiv',
  'trial.active': 'Provperioden är aktiv.',
  'trial.dayLeft': 'Du har {days} dag kvar.',
  'trial.daysLeft': 'Du har {days} dagar kvar.',
  'trial.body': 'Allt fungerar - ha kul när du lär känna Plumme.',
  'trial.upgrade': 'Uppgradera',
  'home.greeting': 'Hej igen 👋',
  'home.registerSale': 'Registrera försäljning',
  'home.registerSaleHelp': 'Registrera en ny försäljning eller skapa en faktura till en kund. Försäljningen bokförs automatiskt på rätt konto.',
  'home.registerPurchase': 'Registrera inköp',
  'home.registerPurchaseHelp': 'Registrera ett inköp eller ladda upp en verifikation. SuperPlumma föreslår konto och momsbehandling åt dig.',
  'home.aiHelp': 'Här ser du allt som SuperPlumma och hans agenter har gjort automatiskt – bokföring, moms, lön och mer. Du godkänner med ett tryck.',
  'home.autopilot.active': 'Aktiv',
  'home.autopilot.followUp': 'Behöver följas upp',
  'home.autopilot.disabled': 'Inaktiverad',
  'home.view.period': 'Period',
  'home.view.analysis': 'Analys',
  'home.view.cashflow': 'Nettoresultat',
  'home.viewLabel.period': 'Intäkter och kostnader per månad',
  'home.viewLabel.analysis': 'Fördelning intäkter vs. kostnader',
  'home.viewLabel.cashflow': 'Nettoresultat per månad',
  'home.ana.ring': 'Fördelning',
  'home.ana.gauge1': 'Nyckeltal',
  'home.ana.gauge2': 'Finansiella nyckeltal',
  'home.sub.yoyArrow': 'Pilen visar förändring från i fjol.',
  'home.sub.exVat': 'Alla summor visas exkl. moms.',
  'home.legend.in': 'In',
  'home.legend.out': 'Ut',
  'home.legend.income': 'Intäkter',
  'home.legend.cost': 'Kostnader',
  'home.legend.result': 'Resultat',
  'home.legend.cashflow': 'Resultat',
  'home.selectedMonths': 'Valda månader:',
  'home.reset': 'Återställ',
  'home.sumOfMonth': 'Summa av {n} månad',
  'home.sumOfMonths': 'Summa av {n} månader',
  'home.noPrevPeriod': 'Ingen föregående period',
  'home.fromPrevMonth': 'från föregående månad',
  'home.fromLastYear': 'från i fjol',
  'home.showDistribution': 'Visa fördelning',
  'home.noData': 'Inga data',
  'home.donut.registeredIncome': 'Registrerade intäkter',
  'home.donut.registeredCosts': 'Registrerade kostnader',
  'home.donut.income': 'Intäkter',
  'home.donut.costs': 'Kostnader',
  'home.donut.result': 'Resultat',
  'home.donut.breakdown': '{title} — fördelning',
  'home.donut.back': 'Tillbaka',
  'home.donut.hint': 'Tryck på en del av ringen eller ett KPI-kort nedan för att se fördelningen',
  'home.health.good': 'Bra',
  'home.health.balanced': 'Balanserad',
  'home.health.weak': 'Svag',
  'home.gauge.explain': 'Förklara nyckeltalet',
  'home.gauge.currentValue': 'Nuvarande värde',
  'home.gauge.assessment': 'Bedömning',
  'home.gauge.goodLevel': 'Bra nivå: {good}',
  'home.gauge.income': 'Intäkter',
  'home.gauge.income.info': 'Intäkter är summan av allt företaget har sålt under perioden, exklusive moms. Stigande intäkter över tid ger större handlingsutrymme.',
  'home.gauge.income.good': 'Stigande över tid',
  'home.gauge.costs': 'Kostnader',
  'home.gauge.costs.info': 'Kostnader är de utgifter som krävs för att driva företaget, exklusive moms. Lägre kostnader i förhållande till intäkterna ger bättre resultat.',
  'home.gauge.costs.good': 'Lägre än intäkterna',
  'home.gauge.result': 'Resultat',
  'home.gauge.result.info': 'Resultatet är det som blir kvar när kostnaderna dras från intäkterna. Positivt resultat betyder vinst under perioden.',
  'home.gauge.result.good': 'Positivt och stabilt',
  'home.gauge.liquidity': 'Likviditet',
  'home.gauge.liquidity.info': 'Likviditet visar förmågan att betala räkningar och kortfristiga skulder när de förfaller. Högre värde ger bättre buffert.',
  'home.gauge.liquidity.good': 'Över 1,0x, helst över 2,0x',
  'home.gauge.profitability': 'Lönsamhet',
  'home.gauge.profitability.info': 'Lönsamhet visar hur stor andel av intäkterna som blir kvar som resultat. Ju högre procent, desto mer tjänar företaget per såld krona.',
  'home.gauge.profitability.good': 'Positiv och stigande',
  'home.gauge.solidity': 'Soliditet',
  'home.gauge.solidity.info': 'Soliditet visar hur stor del av företaget som är finansierat med eget kapital. Högre soliditet gör företaget mer robust.',
  'home.gauge.solidity.good': 'Högre andel eget kapital över tid',
  'home.assistant.sub': 'Bokföringsassistent',
  'home.assistant.intro': 'Hej! Jag kan göra enkla åtgärder åt dig, skapa fakturor, registrera köp, förklara skatter och avgifter och bokföra verifikationer från inkorgen. Fråga på. Vill du ha ekonomisk rådgivning finns rådgivaren på sidan AI Rådgivare.',
  'home.assistant.thinking': 'SuperPlumma tänker...',
  'home.assistant.placeholder': 'Fråga SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma fick inget svar från backend.',
  'home.assistant.errorReply': 'Kunde inte hämta svar från assistenten just nu.',
  'home.assistant.errorToast': 'Kunde inte hämta assistentsvar.',
  'home.assistant.cancel': 'Avbryt',
  'home.assistant.opened': 'Jag öppnade rätt sida med förslaget klart för kontroll.',
  'home.assistant.openedToast': 'Öppnade rätt flöde',
  'home.assistant.noAdapter': 'Den här åtgärden har ingen Plumme-adapter ännu.',
  'home.assistant.paymentNotConnected': 'Betalningsregistrering är inte kopplad till backend.',
  'home.assistant.paymentRegistered': 'Betalning på {sum} har registrerats på faktura{number}.',
  'home.assistant.paymentToast': 'Betalning registrerad',
  'home.assistant.paymentFailed': 'Kunde inte registrera betalningen.',
  'home.assistant.cancelled': 'Okej, jag gjorde ingen ändring.',
  'home.assistant.sugg1': 'Hur mycket är jag skyldig i skatter och avgifter?',
  'home.assistant.sugg2': 'Skapa en faktura till en kund',
  'home.assistant.sugg3': 'Vad är moms?',
  'home.action.register_payment': 'Godkänn betalning',
  'home.action.create_invoice': 'Öppna fakturautkast',
  'home.action.create_other_sale': 'Öppna annan försäljning',
  'home.action.create_expense': 'Öppna nytt köp',
  'home.action.register_purchase': 'Öppna nytt köp',
  'home.action.create_customer': 'Spara kund',
  'home.action.create_supplier': 'Spara leverantör',
  'home.action.create_product': 'Spara produkt',
  'home.action.suggest_accounting_entry': 'Öppna fri kontering',
  'home.action.create_mileage_entry': 'Öppna körjournal',
  'home.action.send_sales_document': 'Öppna fakturalista',
  'home.action.book_bank_lines': 'Öppna bank',
  'home.action.link_bank_receipts': 'Öppna bank',
  'home.action.annul_bank_posting': 'Öppna bank',
  'home.action.reporting_preparation': 'Öppna inlämningar',
  'home.action.default': 'Öppna flöde',
  'home.followup.title': 'Uppföljning',
  'home.followup.allClear': 'Allt är under kontroll',
  'home.followup.allClearSub': 'Inget att följa upp just nu. Plumme säger till när något behöver uppmärksamhet.',
  'home.followup.next': 'Gå vidare',
  'home.followup.showMore': 'Visa mer',
  'home.followup.modalTitle': 'Uppgifter som måste lösas',
  'home.followup.sales': 'Försäljning',
  'home.followup.purchases': 'Köp',
  'home.followup.toInvoiceList': 'Gå till fakturalista',
  'home.followup.toVoucherList': 'Gå till verifikationslista',
  'home.followup.draftInvoices': 'Du har {n} fakturautkast som inte är färdigställda.',
  'home.followup.unsentInvoices': 'Du har {n} fakturor som är klara men inte skickade.',
  'home.followup.overdueInvoices': 'Du har {n} obetalda förfallna fakturor.',
  'home.followup.openPurchases': 'Du har {n} obetalda leverantörsfakturor.',
  'home.followup.missingAttachments': 'Du har {n} köp utan verifikation.',
  'home.followup.bank': 'Bankavstämning',
  'home.followup.toBank': 'Gå till bankavstämning',
  'home.followup.missingBankStatements': 'Företagskontot saknar kontoutdrag för {months}',
  'home.overview.sales': 'Försäljning',
  'home.overview.purchases': 'Köp',
  'home.overview.outstandingSales': 'Utestående försäljning',
  'home.overview.outstandingPurchases': 'Utestående köp',
  'home.overview.salesHelp': 'Utestående försäljning är fakturor som dina kunder ännu inte har betalat. Grönt är inom förfallodatum, gult är förfallet — följ upp de förfallna med en påminnelse.',
  'home.overview.purchasesHelp': 'Utestående köp är leverantörsfakturor som du ännu inte har betalat. Grönt är inom förfallodatum, gult är förfallet och bör betalas snart.',
  'home.overview.importedSubledger': 'Varav importerad reskontra: {amount}',
  'home.overview.inclVat': 'Beloppen är inkl. moms.',
  'home.overview.helpTitle': 'Utestående {what}',
  'home.overview.withinDue': 'Inom förfallodatum',
  'home.overview.overdue': 'Förfallet',
  'home.overview.statusTitle': '{within} % inom förfallodatum · {over} % förfallet',
  'home.deadlines.title': 'Kommande tidsfrister',
  'home.deadlines.help': 'Kommande inlämningsfrister - MVA-melding, skattemelding, årsredovisning och aksjonærregisteroppgave, med status för varje.',
  'home.deadlines.none': 'Inga tidsfrister hittades i backend-data.',
  'home.deadlines.seeStatus': 'Visa status',
  'home.deadlines.helpTax': 'Skattemeldingen samlar bokföring och skatteberäkning för året. Plumme hjälper dig att kontrollera siffrorna före inlämning.',
  'home.deadlines.helpAnnualAccounts': 'Årsredovisningen samlar resultaträkning, balansräkning och noter för räkenskapsåret och skickas till Regnskapsregisteret när den är klar.',
  'home.deadlines.helpAnnualClosing': 'Bokslutet stänger räkenskapsåret med kontroller, disposition och nödvändiga bokslutskonteringar.',
  'home.deadlines.helpShareholderRegister': 'Aksjonærregisteroppgaven (RF-1086) lämnas av aktiebolag senast 31 januari året efter inkomståret. Plumme har ingen inlämning för den — det här är en påminnelse.',
  'home.deadlines.helpVat': 'MVA-meldingen rapporterar utgående och ingående moms för perioden.',
  'home.deadlines.helpFallback': 'Tidsfrist för {name}. Plumme meddelar och hjälper dig vidare från statusvyn.',
  'home.deadlines.fallbackName': 'inlämning',
  'home.deadlines.name.shareholderRegister': 'Aksjonærregisteroppgaven',
  'home.fees.title': 'Offentliga avgifter',
  'home.fees.help': 'Översikt över vad du är skyldig det allmänna just nu - moms, skatteavdrag och arbetsgivaravgift. Beräknas löpande från bokföringen.',
  'home.fees.none': 'Inga öppna offentliga avgifter hittades.',
  'home.balances.title': 'Saldo',
  'home.balances.help': 'Bokfört saldo på bank-, kassa- och andra konton. Siffrorna kommer från råbalansen, så de visar vad bokföringen säger - inte vad banken har hunnit uppdatera. Med kugghjulet väljer du vilka konton som visas och kan söka fram fler i kontoplanen. Företagskontot och kassan kan döljas, men inte tas bort.',
  'home.balances.choose': 'Välj konton',
  'home.balances.total': 'Totalt',
  'home.balances.accountFallback': 'Konto {code}',
  'home.balances.noneSelected': 'Inga konton valda.',
  'home.balances.searchPlaceholder': 'Sök i kontoplanen …',
  'home.balances.noHits': 'Inga träffar',
  'home.balances.remove': 'Ta bort från kortet',
  'home.balances.saveFailed': 'Kunde inte spara kontovalet.',
  'set.account': 'Konto',
  'set.amount': 'Belopp',
  'set.page': 'Sida',
  'set.debit': 'Debet',
  'set.credit': 'Kredit',
  'set.remove': 'Ta bort',
  'set.ib.title': 'Ingående balans',
  'set.ib.startWizard': 'Starta guiden för att skapa ingående balans',
  'set.ib.confirmDate': 'Bekräfta startdatumet',
  'set.ib.setUp': 'Ställ in ingående balans',
  'set.ib.confirmDateInPlumme': 'Bekräfta startdatumet i Plumme',
  'set.ib.startDate': 'Startdatum',
  'set.back': 'Tillbaka',
  'set.ib.dateOk': 'Datumet stämmer, gå vidare',
  'set.ib.draftEmpty': 'Utkastet är tomt.',
  'set.text': 'Text',
  'set.toDebit': 'Till (debet)',
  'set.fromCredit': 'Från (kredit)',
  'set.editLine': 'Redigera rad',
  'set.removeLine': 'Ta bort rad',
  'set.quickPick': 'Snabbval',
  'set.addNewLine': 'Lägg till ny rad',
  'set.saved': 'Sparat',
  'set.startOver': 'Börja om',
  'set.ib.finish': 'Slutför ingående balans',
  'set.ib.summary': 'Sammanfattning - belopp in och ut från konton',
  'set.ib.openNote': 'Konteringen är öppen och kan ändras från den här vyn.',
  'set.ib.intoAccount': 'In på konto',
  'set.ib.outOfAccount': 'Ut från konto',
  'set.sum': 'Summa',
  'set.ib.openEntry': 'Öppen kontering',
  'set.accountNo': 'Kontonr',
  'set.name': 'Namn',
  'set.vatCode': 'Momskod',
  'set.description': 'Beskrivning',
  'set.relevantLinks': 'Relevanta länkar',
  'set.deleteCancel': 'Ta bort / makulera',
  'set.ib.edit': 'Ändra ingående balans',
  'set.ib.openingForAccount': 'Ingående saldo för konto',
  'set.cancel': 'Avbryt',
  'set.save': 'Spara',
  'set.ib.postDescription': 'Beskrivning av posten',
  'set.pickAccount': 'Välj konto ...',
  'set.accountDebit': 'Konto (debet)',
  'set.ib.cannotBeEmpty': 'Kan inte skapa tom ingående balans',
  'set.continueTitle': 'Fortsätta?',
  'set.ib.post': 'Bokför ingående balans',
  'set.ib.draftTitle': 'Utkast för ingående balans',
  'set.ib.draftHelp': 'Lägg in balanssiffror från ditt tidigare system, så att råbalansen startar rätt i Plumme.',
  'set.noteOptional': 'Anteckning (valfritt)',
  'set.notePh': 'Till exempel vad som importerades och från vilket datum',
  'set.ib.lines': 'Balansrader',
  'set.ib.linesHelp': 'Balanssiffrorna vid övergångsdatumet, fördelade per konto: tillgångar, eget kapital och skulder från det gamla systemet. För en rad per konto så att balansen startar med rätt siffror i Plumme.',
  'set.ib.addLine': 'Lägg till balansrad',
  'set.startup.title': 'Startsiffror',
  'set.startup.introText': 'Använd detta om du flyttar till Plumme mitt under {year}. Du för in moms och resultatsiffror från ditt tidigare system, så att rapporterna och skattemeldingen fortsätter rätt från övergångsdatumet.',
  'set.startup.startWizard': 'Starta guiden för att lägga in startsiffror',
  'set.startup.stepDate': 'Övergångsdatum och moms',
  'set.startup.stepLines': 'Försäljning och kostnader',
  'set.startup.confirmTitle': 'Bekräfta övergångsdatum och moms hittills',
  'set.startup.linesTitle': 'Fördela siffrorna före {date}',
  'set.startup.save': 'Spara startsiffror',
  'set.startup.receiptTitle': 'Startsiffror per {date}',
  'set.startup.receiptSub': 'Sparat för övergången till Plumme',
  'set.startup.receiptLines': '{lines} rader registrerade - {sales} försäljning och {costs} kostnad.',
  'set.startup.edit': 'Ändra startsiffror',
  'set.transitionDate': 'Övergångsdatum',
  'set.transitionDateHelp': 'Datumet då du gick över till Plumme. Startsiffrorna gäller perioden från årets början fram till detta datum, förda i det gamla systemet.',
  'set.outputVatBefore': 'Utgående moms före start',
  'set.outputVatBeforeHelp': 'Moms du redan har tagit ut på försäljning hittills i år, före övergången. Läggs till årets momssiffror så att MVA-meldingen blir rätt.',
  'set.inputVatBefore': 'Ingående moms före start',
  'set.inputVatBeforeHelp': 'Moms du redan har betalat på köp hittills i år (och har avdrag för), före övergången.',
  'set.salesByAccount': 'Försäljning fördelad per konto',
  'set.salesByAccountHelp': 'Försäljningsintäkterna hittills i år, fördelade per intäktskonto. För en rad per försäljningskonto så att resultaträkningen startar med rätt siffror.',
  'set.salesByAccountBefore': 'Försäljning fördelad per konto före start',
  'set.addSalesLine': 'Lägg till försäljningsrad',
  'set.noSalesLines': 'Inga försäljningsrader ännu.',
  'set.costsByAccount': 'Kostnader fördelade per konto',
  'set.costsByAccountHelp': 'Kostnaderna hittills i år, fördelade per kostnadskonto. För en rad per kostnadskonto så att resultatet blir rätt från övergångsdatumet.',
  'set.costsByAccountBefore': 'Kostnader fördelade per konto före start',
  'set.addCostLine': 'Lägg till kostnadsrad',
  'set.noCostLines': 'Inga kostnadsrader ännu.',
  'set.import.title': 'Importera komplett bokföring',
  'set.import.pickPackage': 'Välj exportfiler',
  'set.import.shouldContain': 'Paketet bör innehålla',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Kund- och leverantörsregister, gärna Excel eller CSV',
  'set.import.chart': 'Kontoplan',
  'set.import.vouchers': 'Verifikationer, kvitton och fakturor som PDF eller bilder',
  'set.import.bankRecs': 'Bankavstämningar och fakturakopior',
  'set.import.firstStep': 'Första steget i Plumme',
  'set.import.readsStructure': 'Läser filstrukturen',
  'set.import.findsFiles': 'Hittar SAF-T, Excel och verifikationsfiler',
  'set.import.buildsAnalysis': 'Skapar en importanalys',
  'set.import.letsApprove': 'Låter dig godkänna säker import av kontoplan, kunder, leverantörer och ingående balans',
  'set.import.notAutomatic': 'Inte automatiskt ännu',
  'set.import.noPromise': 'Plumme lovar inte att allt blir exakt identiskt med ditt tidigare system',
  'set.import.noHistoric': 'Historiska konteringar bokförs inte utan godkännande',
  'set.import.nothingToAltinn': 'Ingenting skickas till Altinn',
  'set.import.noOverwrite': 'Befintliga verifikationer tas inte bort eller skrivs över utan bekräftelse',
  'set.close': 'Stäng',
  'set.import.approveBase': 'Godkänn import av grunddata',
  'set.import.working': 'Arbetar...',
  'set.import.uploading': 'Uppladdning till Firebase Storage',
  'set.import.serverReading': 'Servern läser importfilerna nu',
  'set.import.importingBase': 'Importerar grunddata',
  'set.import.savedInAccounts': 'Importen är sparad i bokföringen',
  'set.import.checkBefore': 'Kontrollera kontoplan, kunder, leverantörer och ingående balans före rapportering.',
  'set.import.dataOnlyTitle': 'Importera endast bokföringsdata (rekommenderas)',
  'set.import.dataOnlyHelp': 'Plumme skapar en filtrerad kopia i webbläsaren med SAF-T, CSV och Excel. PDF:er, bilder och andra dokument laddas inte upp.',
  'set.import.dataOnlyKeepOriginal': 'Behåll den ursprungliga ZIP-filen från Fiken.',
  'set.import.dataOnlyFiltering': 'Tar bort dokument före uppladdning',
  'set.import.dataOnlyFilteringHelp': 'Originalfilen ändras inte. Bara det nya, filtrerade datapaketet skickas till Plumme.',
  'set.import.dataOnlyFiltered': '{count} dokument- och verifikationsfiler utelämnades från uppladdningen.',
  'set.import.dataOnlyLibraryFailed': 'Kunde inte läsa in ZIP-filtret. Försök igen eller packa upp SAF-T, CSV och Excel manuellt.',
  'set.import.dataOnlyNoFiles': 'Hittade inga SAF-T-, CSV- eller Excel-filer i ZIP-paketet.',
  'set.import.packages.title': 'Sparade importpaket',
  'set.import.packages.help': 'Här ser du alla ZIP-filer och vilket paket som är aktiv källa för importarkivet.',
  'set.import.packages.loading': 'Läser in paket...',
  'set.import.packages.empty': 'Inga sparade ZIP-filer.',
  'set.import.packages.statusImported': 'Aktiv import',
  'set.import.packages.statusDuplicate': 'Identisk dubblett',
  'set.import.packages.statusPrevious': 'Tidigare import',
  'set.import.packages.statusAnalyzed': 'Avläst',
  'set.import.packages.statusFailed': 'Avläsning misslyckades',
  'set.import.packages.statusAnalyzing': 'Läses av',
});
